module.exports = __webpack_public_path__ + "img/excel-icon.7a6c612.png";